import styled from "styled-components"
import {Label1} from "@irati/ui/src/Labels"

const TotalLabel = styled(Label1)`
  position: relative;
  top: 5px;
`

export default TotalLabel
